import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HelpDialog from './HelpDialog';
import { HELP_CONTENT, HelpKey } from './helpContent';

/**
 * Drop-in "?" help button + flow-diagram dialog for a page. Content comes from
 * the central registry (helpContent.tsx) so every page shares one consistent,
 * reviewable source of plain-language guidance.
 *
 * Usage: place <PageHelp k="drivers" /> next to a page title.
 */
const PageHelp: React.FC<{ k: HelpKey; size?: 'small' | 'medium' }> = ({ k, size = 'small' }) => {
  const [open, setOpen] = useState(false);
  const content = HELP_CONTENT[k];
  if (!content) return null;
  return (
    <>
      <Tooltip title="How this works">
        <IconButton
          size={size}
          onClick={() => setOpen(true)}
          aria-label="Help — how this works"
          color="info"
          sx={{ color: 'info.main' }}
        >
          <HelpOutlineIcon fontSize={size} />
        </IconButton>
      </Tooltip>
      <HelpDialog open={open} onClose={() => setOpen(false)} {...content} />
    </>
  );
};

export default PageHelp;
